module.exports = __webpack_public_path__ + "static/media/student-snapshort2-score.e8ba9efa.png";